import React from 'react'

const RemainingTime = ({ minutes, seconds, title }) => {
    return (
        <div className='px-3 pt-3 pb-4 rounded-xl border border-dashed border-danger'>
            {title}
            <div className='mt-3 flex justify-center gap-3'>
                <div className='flex flex-col items-center'>
                    <p className='text-xl font-bold'>00</p>
                    <p className='text-xxs text-text-time'>Hours</p>
                </div>
                <p className='text-xl'>:</p>
                <div className='flex flex-col items-center'>
                    <p className='text-xl font-bold'>{minutes.toString().padStart(2, '0')}</p>
                    <p className='text-xxs text-text-time'>Minutes</p>
                </div> 
                <p className='text-xl'>:</p>
                <div className='flex flex-col items-center'>
                    <p className='text-xl font-bold'>{seconds.toString().padStart(2, '0')}</p>
                    <p className='text-xxs text-text-time'>Seconds</p>
                </div>
            </div>
        </div>
    )
}

export default RemainingTime